<template>
  <div v-if="fullList && fullList.length > tableSize">
    <el-pagination
      @current-change="currentChange"
      :current-page="tableIndex"
      :page-size="tableSize"
      layout="prev,pager,next"
      :total="fullList.length"
      :pager-count="5"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: "PaginationFunctional",
  props: {
    sublistName: String,
    fullList: Array,
    tableSize: Number,
    tableIndexInitial: Number,
  },
  created: function () {
    // Preserve initial page from parent/query without emitting when data isn't loaded yet
    if (this.fullList && this.fullList.length > 0) {
      this.currentChange(this.tableIndexInitial || this.tableIndex);
    } else {
      this.tableIndex = this.tableIndexInitial || this.tableIndex;
    }
  },
  computed: {
    npages() {
      return Math.ceil(this.fullList.length / this.tableSize);
    },
    // currentPage() {
    //   return this.fullList.slice(
    //     this.tableSize * (this.tableIndex - 1),
    //     this.tableSize * this.tableIndex
    //   );
    // },
  },
  methods: {
    currentChange(index) {
      if (!this.fullList) return;

      // Math.clamp(1, index, this.npages) is current proposal to ES2017
      this.tableIndex = Math.max(1, Math.min(index, this.npages));

      this.$emit("paginationChange", {
        sublistName: this.sublistName,
        list: this.currentPage(),
      });
      this.$emit("currentIndexPagination", this.tableIndex);
    },

    currentPage() {
      return this.fullList.slice(
        this.tableSize * (this.tableIndex - 1),
        this.tableSize * this.tableIndex
      );
    },

    handleSortChangePagination(event, listOverride = null) {
      const workingList = Array.isArray(listOverride)
        ? listOverride
        : Array.isArray(this.fullList)
        ? this.fullList
        : [];

      if (!workingList.length) {
        return [...workingList];
      }

      const prop = event && event.prop ? event.prop : null;
      const order = event && event.order ? event.order : null;

      if (!prop || !order) {
        return [...workingList];
      }

      return [...workingList].sort((a, b) => {
        const aValue = this.extractValueByPath(a, prop);
        const bValue = this.extractValueByPath(b, prop);
        return this.compareValues(aValue, bValue, order, prop);
      });
    },

    extractValueByPath(row, path) {
      if (!row || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, row);
    },

    compareValues(aValue, bValue, order, prop = null) {
      const aEmpty = this.isEmptyValue(aValue);
      const bEmpty = this.isEmptyValue(bValue);
      
      // Empty/null values always go to the end, regardless of sort direction
      if (aEmpty && bEmpty) {
        return 0;
      }
      if (aEmpty) {
        // Use a large positive value to ensure empty always goes to end
        return Number.MAX_SAFE_INTEGER;
      }
      if (bEmpty) {
        // Use a large negative value to ensure empty always goes to end
        return -Number.MAX_SAFE_INTEGER;
      }

      const direction = order === "descending" ? -1 : 1;

      // Certain props (like 'batch') should always be treated as strings,
      // even if they look numeric (e.g. to preserve leading zeros).
      const forceStringProps = ["batch"];
      const treatAsString = prop && forceStringProps.includes(prop);

      // Generic behavior: if both values are numeric, sort numerically;
      // otherwise, sort as strings. But never treat forced-string props as numeric.
      if (!treatAsString && this.isNumericValue(aValue) && this.isNumericValue(bValue)) {
        return (Number(aValue) - Number(bValue)) * direction;
      }

      const comparison = String(aValue).localeCompare(String(bValue), undefined, {
        sensitivity: "base",
      });
      return comparison * direction;
    },

    isEmptyValue(value) {
      if (value === null || value === undefined) {
        return true;
      }
      if (typeof value === "string") {
        return value.trim() === "";
      }
      return value === "";
    },

    isNumericValue(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },


  },
  watch: {
    fullList(newVal) {
      if (newVal && newVal.length > 0) {
        // Apply the preserved initial index once data is available
        this.currentChange(this.tableIndex);
      }
    },
  },
  data() {
    return {
      tableIndex: 1,
    };
  },
};
</script>

<style>
</style>
